/**
 * /customers/:customerKey
 *
 * A page on desktop, a full sheet on phone, never a drawer. The key in the URL is the
 * opaque ck_ handle for a masked role and the raw key for the owner; the API resolves
 * either, so one link works for both without putting an email in an agent's address bar.
 */
import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { useSession } from '@/app/session';
import { CustomerProfile } from '@/features/customers/CustomerProfile';

function CustomerProfilePage() {
  const { customerKey } = Route.useParams();
  const { role } = useSession();
  return <CustomerProfile customerKey={customerKey} role={role ?? 'agent'} />;
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/customers/$customerKey',
  component: CustomerProfilePage,
});
